import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Hero from "./sections/Hero";
import About from "./sections/About";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Expertise from "./sections/Expertise";
import Contact from "./sections/Contact";
import { useActiveSection } from "./ActiveSectionContext";

const SECTION_IDS = ["about", "experience", "projects", "contact"];

function Home() {
  const { hash } = useLocation();
  const { setActiveId } = useActiveSection();

  useEffect(() => {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    target.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "start",
    });
  }, [hash]);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return undefined;

    const elements = SECTION_IDS.map((id) => document.getElementById(id)).filter(
      Boolean
    );
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [setActiveId]);

  return (
    <div className="home">
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Expertise />
      <Contact />
    </div>
  );
}

export default Home;
